import classNames from 'classnames';

import CheckIcon from '../icons/Check';
import Button from './Button';

import styles from '../../../styles/buttons/checkbox.module.css';

interface CheckboxButtonProps {
    checked?: boolean;
    className?: string | null;
    iconClassName?: string | null;
    labelClassName?: string | null;
    isBlack?: boolean;
    disabled?: boolean;
    children?: React.ReactNode;
    onClick?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | null;
}

function CheckboxButton({
    checked = false,
    className = null,
    iconClassName = null,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    labelClassName = null,
    isBlack = false,
    disabled = false,
    children = null,
    ...props
}: CheckboxButtonProps) {
    return (
        <Button
            icon={
                <CheckIcon
                    className={classNames([
                        styles.icon,
                        {
                            [iconClassName]: iconClassName !== null,
                        },
                    ])}
                    checked={checked}
                />
            }
            iconPosition="inline"
            className={classNames([
                styles.container,
                {
                    [styles.isBlack]: isBlack,
                    [styles.disabled]: disabled,
                    [className]: className !== null,
                },
            ])}
            disabled={disabled}
            {...props}
        >
            {children}
        </Button>
    );
}

export default CheckboxButton;
